<template>
  <div class="d-content__section">
    <!-- <div class="row">
      <div class="col-4">
        <upload></upload>
      </div>
      <div class="col-12 margintop-20">
        <btn text="Submit" type="primary" v-on:click="submitFiles"></btn>
      </div>
    </div> -->
    <!-- <pop-up-message
      v-if="showSuccessMsg"
      :message="`Notice-May-2019.exl file submitted.`"
      btnText="Back To Upload Template"
      @back="backfrompopup()"
    /> -->
      <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
              You have only view permission.
      </div>
      <toast-message
          :message="errmsg"
          type="error"
          :isToastEnable="toast"
          @close="(val) => toast = val"
          />
    <div class="row margin-t-l" :disabled="!ifTeamleaderAnchorPermission">

        <div class="col-12 padding-l-n margin-t-15px" :key="componentKey">
          <upload :tobucket="false" @change="onUploadTemplate($event)"></upload>
          <!-- <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" /> -->
        </div>
      </div>

      <bottom-action-container class="placeEnd">
        <template slot="end">
          <btn-grp>
            <btn text="Back" type="secondary" @click="goToPayrollPage"></btn>
            <!-- <btn text="Save" type="primary" @click="submit"></btn> -->
          </btn-grp>
        </template>
      </bottom-action-container>

      <pop-up-message
      v-if="showSuccessBulkUploadMsg"
      :message="responseMsg"
      btnText="Back To Payroll Utilities"
      @back="backfrompopup()"
    />
    <pop-up-message
      v-if="showErrorPopup"
      message=""
      popupType="Warning"
      :popupHeaderMessage="'UPLOAD FAILED!!!'">
      
        <template v-slot:bottomContent>
        <div class=" margintop-32">
          <div class="Rectangle margintop-32">
          <span class="Information-message">{{ logMessage }}</span>
        </div>
    </div>
      <div class="margintop-32 custom-container">
      <a :href="logSheetUrl"
        @click="downloadItem(logSheetUrl)"
      ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
          </div>

          <div class="popup-btn-group margintop-32 marginright">

            <button class="btn-popup" type="button" @click="backfromlogpopup()">Back To Employee Master Update</button>

          <!-- <button class="btn-popup" type="button" @click="uploadFile2($event)">Proceed</button>
                -->  </div>
        </template>
      </pop-up-message>

      <dws-paylief-loading v-if="apiPending"></dws-paylief-loading>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { api_variables } from "@/apis/variables.js";

export default {
  name: "UploadTemplate",
  data() {
    return {
      bulkUploadUrl: api_variables.SERVICE_BULK_EDIT_MASTER_DATA_UPLOAD,
      showSuccessMsg:false,
      showSuccessBulkUploadMsg: false,
      toast: false,
      errmsg: "",
      responseMsg: "",
      downloadUploadMasterTemplateValue: false,
      role: "",
      showErrorPopup:false,
      logSheetUrl: null,
      logMessage: null,
      componentKey: 0,
      apiPending:false,
    };
  },
  computed: {
    ...mapState({
      email: state => state.auth.email
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.downloadUploadMasterTemplateValue) {
          return true;
        } else {
          return false;
        }
      }
      // else {
      //   return true
      // }
    }
  },
  mounted() {
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      uploadBulkData:
        "dashboard/utilities/uploadTemplate",
    }),

    backfrompopup(){
        this.showSuccessBulkUploadMsg = false;
      //  this.$router.push({
      //  path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      //});
      this.$router.go(0);
    },
    backfromlogpopup(){
      this.showErrorPopup = false;
      this.componentKey += 1;
    },
    async onUploadTemplate(event) {

      try {
          let formData = new FormData();
          formData.append("file", event);
          formData.append("le_id", this.le_id);
          formData.append("loggedInUser", this.email);
          this.apiPending = true;
          let res = await this.uploadBulkData(formData)
          if (res && res.data.message == 'Failed') {
            this.apiPending = false
            this.showErrorPopup = true;
            this.logSheetUrl = res.data.payload[0];
          } else if (res && res.data.message == 'Bulk updated successfully') {
            // this.toast = true;
            // this.errmsg = res.message;
            this.apiPending = false
            this.responseMsg = res.data.message ? res.data.message : "";
            this.showSuccessBulkUploadMsg = true;
          }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
        this.apiPending = false
      }
    },

    /* function to go to Level main page */
    goToPayrollPage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`

      });
    },


   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.downloadUploadMasterTemplateValue = data.data.user.permissions.download_upload_master_template ? true : false;
        //console.log("PL-3406",data);
    }

  }
};
</script>

<style lang="scss" scoped>
.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
